import { useEffect, useState } from "react";

// Tracks browser connectivity via the online/offline events so pages can
// show a "Saving / Saved / Offline" indicator and gate submit actions.
export function useOnline() {
    const [online, setOnline] = useState(navigator.onLine);
    useEffect(() => {
        const up = () => setOnline(true);
        const down = () => setOnline(false);
        window.addEventListener("online", up);
        window.addEventListener("offline", down);
        return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
    }, []);
    return online;
}
